export abstract class LanguageService {
    // readonly SUPPORTED_LANGUAGES: string[] = ['fr', 'de', 'nl', 'ru', 'tr', 'en-GB'];
    readonly SUPPORTED_LANGUAGES: string[] = ['de', 'nl', 'ru', 'en-GB'];

    public abstract getLanguage(defaultLanguage: string): string;
}
